import { render, staticRenderFns } from "./add-case.vue?vue&type=template&id=0a51f276&scoped=true&"
import script from "./add-case.vue?vue&type=script&lang=js&"
export * from "./add-case.vue?vue&type=script&lang=js&"
import style0 from "./add-case.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./add-case.vue?vue&type=style&index=1&id=0a51f276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a51f276",
  null
  
)

export default component.exports